export default __webpack_public_path__ + "static/media/fb.ii.d1469bf2.svg";